<template>
  <VContainer class="critical-future-years-page">
    <VRow>
      <VCol cols="12">
        <div class="critical-future-years-page__content">
          <p>HMRC issued very important new rules on 16th March 2026</p>
          <p>
            As a Pension Keeper subscriber, <b>YOU MUST REAPPLY to HMRC before 5 April 2027</b> to be able to buy future
            years up until you reach 35 years National Insurance Contributions (<i>or UK State Pension Age if sooner</i
            >)
          </p>
          <p>After April 2026 everyone pays the same Class 3 rate as the cheaper Class 2 rate is abolished.</p>
          <p><b>To Buy Years after 6 April 2026, you must meet all the following conditions:</b></p>
          <ul>
            <li>you apply to pay Class 3 contributions for the 2026 to 2027 tax year on or before 5 April 2027</li>
            <li>
              you applied to pay voluntary Class 2 or Class 3 contributions for the 2024 to 2025 or 2025 to 2026 tax
              year on or before 5 April 2026 (<i><b>Tip:</b> You did this</i>)
            </li>
            <li>
              you paid the voluntary contributions you applied for on or before 5 April 2027 (<i
                ><b>Tip:</b> You did this</i
              >)
            </li>
          </ul>
          <p><b>REAPPLY TO HMRC BEFORE 5 APRIL 2027</b></p>
          <p>We’re awaiting HMRC clarity expected in August 2026</p>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script>
import { mapActions } from 'vuex';
// Utils
export default {
  name: 'CriticalFutureYearsPage',
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    navigateTo(pageName) {
      if (!pageName) {
        return;
      }
      this.$router.push({ name: pageName });
    }
  }
};
</script>
